const UserNameToAvatarMapper = (userName) => {
  let avatar = '';
  if (userName && userName.length) {
    const usrName = userName[0].userName;
    const splitUsrname = userName.split(' ');
    if (splitUsrname.length >= 2) {
      avatar = splitUsrname[0].charAt(0) + splitUsrname[1].charAt(0);
    } else avatar = usrName;
  }
  return avatar;
};

export default UserNameToAvatarMapper;



// WEBPACK FOOTER //
// ./src/utils/mappers/UserNameToAvatarMapper.js